import axios from "axios";
import { ip_back } from "../config";

function authHeaders() {
  const token = localStorage.getItem("token");
  return { headers: { Authorization: token } };
}

export async function fetchPublicRental(clubCode, lang) {
  const res = await axios.get(`${ip_back}api/public/rental/${clubCode}`, {
    params: { lang },
  });
  return res.data;
}

export async function fetchPublicSlots(clubCode, { offeringId, date, durationMinutes }) {
  const res = await axios.get(`${ip_back}api/public/rental/${clubCode}/slots`, {
    params: {
      offering_id: offeringId,
      date,
      duration_minutes: durationMinutes,
    },
  });
  return res.data;
}

export async function fetchOpenChallenges(clubCode, lang) {
  const res = await axios.get(`${ip_back}api/public/rental/${clubCode}/challenges`, {
    params: { lang },
  });
  return res.data;
}

export async function createPublicBooking(clubCode, payload) {
  const res = await axios.post(`${ip_back}api/public/rental/${clubCode}/bookings`, payload);
  return res.data;
}

export async function acceptChallenge(clubCode, challengeId, payload) {
  const res = await axios.post(
    `${ip_back}api/public/rental/${clubCode}/challenges/${challengeId}/accept`,
    payload
  );
  return res.data;
}

export async function fetchBookingConfirmation(clubCode, bookingId, lang) {
  const res = await axios.get(
    `${ip_back}api/public/rental/${clubCode}/bookings/${bookingId}/confirmation`,
    { params: { lang } }
  );
  return res.data;
}

export async function adminListOfferings(clubId, lang) {
  const res = await axios.get(`${ip_back}api/rental/${clubId}/offerings`, {
    ...authHeaders(),
    params: { lang },
  });
  return res.data;
}

export async function adminSaveOffering(clubId, payload) {
  const method = payload.offering_id ? "put" : "post";
  const res = await axios[method](`${ip_back}api/rental/${clubId}/offerings`, payload, authHeaders());
  return res.data;
}

export async function adminDeleteOffering(clubId, offeringId) {
  const res = await axios.delete(
    `${ip_back}api/rental/${clubId}/offerings/${offeringId}`,
    authHeaders()
  );
  return res.data;
}

export async function adminSeedOfferings(clubId) {
  const res = await axios.post(`${ip_back}api/rental/${clubId}/offerings/seed`, {}, authHeaders());
  return res.data;
}

export async function adminListClubTables(clubId) {
  const res = await axios.get(`${ip_back}api/rental/${clubId}/tables`, authHeaders());
  return res.data;
}

export async function adminListAvailabilities(clubId) {
  const res = await axios.get(`${ip_back}api/rental/${clubId}/availabilities`, authHeaders());
  return res.data;
}

export async function adminSaveAvailability(clubId, payload) {
  const method = payload.availability_id ? "put" : "post";
  const res = await axios[method](
    `${ip_back}api/rental/${clubId}/availabilities`,
    payload,
    authHeaders()
  );
  return res.data;
}

export async function adminDeleteAvailability(clubId, availabilityId) {
  const res = await axios.delete(
    `${ip_back}api/rental/${clubId}/availabilities/${availabilityId}`,
    authHeaders()
  );
  return res.data;
}

export async function adminListBookings(clubId, params = {}) {
  const res = await axios.get(`${ip_back}api/rental/${clubId}/bookings`, {
    ...authHeaders(),
    params,
  });
  return res.data;
}

export async function adminCancelBooking(clubId, bookingId) {
  const res = await axios.post(
    `${ip_back}api/rental/${clubId}/bookings/${bookingId}/cancel`,
    {},
    authHeaders()
  );
  return res.data;
}

export async function adminGetRentalSettings(clubId) {
  const res = await axios.get(`${ip_back}api/rental/${clubId}/settings`, authHeaders());
  return res.data;
}

export async function adminUpdateRentalSettings(clubId, payload) {
  const res = await axios.put(`${ip_back}api/rental/${clubId}/settings`, payload, authHeaders());
  return res.data;
}

export async function adminStripeOnboarding(clubId) {
  const res = await axios.post(
    `${ip_back}api/rental/${clubId}/stripe/onboarding`,
    {},
    authHeaders()
  );
  return res.data;
}

export async function adminStripeStatus(clubId) {
  const res = await axios.get(`${ip_back}api/rental/${clubId}/stripe/status`, authHeaders());
  return res.data;
}
